import React from 'react';

import {
	useClassNames,
} from '@common';

import './Radio.scss';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: JSX.Element,
    radioGroup: string;
	className?: string,
	defaultBoolValue?: boolean,
	boolValue?: boolean,
	onValueChange?: (newValue: boolean) => void
}

function Radio(props: RadioProps): JSX.Element {
	const {
		className,
		label,
		radioGroup,
		boolValue,
		onValueChange
	} = props;

	const classes = useClassNames(
		'radiobox',
		className,
	);

	const onInputChange = (ev) => {
		if (onValueChange) {
			onValueChange(ev.target.checked ? true : false);
		}
	}

    const id = `${radioGroup}_${label}`;

	return (
		<div className={classes}>
			<input
				className="radiobox__input"
				name={radioGroup}
				id={id}
				type="radio"
				// defaultChecked={defaultBoolValue}
				checked={boolValue}
				onChange={onInputChange}
			/>
			{label && <label htmlFor={id} className="radiobox__label">{label}</label>}
		</div>
	);
}

const MemoisedRadio = React.memo(Radio);

export {MemoisedRadio as Radio};